import { render, staticRenderFns } from "./ClaimDocumentCreate.vue?vue&type=template&id=540d19ee&"
import script from "./ClaimDocumentCreate.vue?vue&type=script&lang=js&"
export * from "./ClaimDocumentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports